module.exports = __webpack_public_path__ + "static/media/Puma_Female_Right_low.acb5f4a4.jpg";